import { Link } from 'react-router-dom';

export function BridgeSection() {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-8">
        {/* Headline */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-black uppercase mb-4 text-foreground">
            One Legacy, Two Ways to Build Your Office
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-red-600 to-primary mx-auto"></div>
        </div>

        {/* Two Options Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Left Side - EzeeFit */}
          <div className="bg-gradient-to-br from-red-50 to-orange-50 border-2 border-red-100 p-8 text-center hover:shadow-xl transition-all duration-300 hover:border-red-300 group">
            <img 
              src="https://customer-assets.emergentagent.com/job_modshop-seo/artifacts/us9gplcj_image.png"
              alt="Ezeefit - Fits Your World"
              className="h-28 w-auto mx-auto mb-6 group-hover:scale-105 transition-transform duration-300"
            />
            <h3 className="text-xl font-bold text-red-800 mb-3">
              Need a Fully Customized Floor Plan?
            </h3>
            <p className="text-gray-600 mb-6 text-sm">
              Made-to-order projects for complete office transformations
            </p>
            <p className="text-red-700 font-bold text-sm">
              www.ezeefitofficesystems.in
            </p>
            <p className="text-xs text-gray-500 mt-3 italic">
              Modular Office Furniture Suppliers & Manufacturers in Mumbai
            </p>
          </div>

          {/* Right Side - Modular Furniture Store */}
          <div className="bg-gradient-to-br from-blue-50 to-purple-50 border-2 border-primary/20 p-8 text-center hover:shadow-xl transition-all duration-300 hover:border-primary/50 group">
            <img 
              src="https://customer-assets.emergentagent.com/job_modshop-seo/artifacts/3hgcnplr_image.png"
              alt="Modular Furniture Store"
              className="h-28 w-auto mx-auto mb-6 group-hover:scale-105 transition-transform duration-300"
            />
            <h3 className="text-xl font-bold text-primary mb-3">
              Need Standard, Ready-to-Ship Solutions?
            </h3>
            <p className="text-gray-600 mb-6 text-sm">
              Browse our catalog and order online with free delivery
            </p>
            <Link 
              to="/products"
              className="inline-flex items-center gap-2 bg-primary hover:bg-primary/90 text-white font-bold px-6 py-3 rounded-full transition-all duration-300 hover:scale-105 text-sm"
            >
              Stay Here & Shop Online
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </Link>
            <p className="text-xs text-gray-500 mt-3 italic">
              Quick delivery in Mumbai & Navi Mumbai
            </p>
          </div>
        </div>

        {/* Center Caption */}
        <div className="text-center mt-10">
          <p className="text-lg text-gray-600 font-medium max-w-2xl mx-auto">
            Whether it's one desk or a whole floor, you're backed by a <span className="font-bold text-foreground">decade of manufacturing expertise</span>.
          </p>
        </div>
      </div>
    </section>
  );
}
